const is = {
  ie11: !!window.MSInputMethodContext && !!document.documentMode
}

Object.keys(is)
  .forEach((browser) => {
    if (is[browser]) document.documentElement.classList.add(browser)
  })
